import { Link, useLocation } from "react-router-dom";
import { activeChild, hubFor } from "../nav";
import { CountBadge, countFor, drillFor, useNavCounts } from "../hooks/useNavCounts";

// Slim sub-tab strip shown above a hub's pages (Deals · Jobs · Dispatch · Team · Money · Marketing).
// Derived from nav.js with the same matcher as the sidebar, so both levels always agree. Live counts tell you where to look next.
export function HubStrip() {
  const loc = useLocation();
  const counts = useNavCounts();
  const hub = hubFor(loc);
  if (!hub) return null;
  const active = activeChild(hub, loc);
  return (
    <div className="hub-nav" data-testid={`hub-nav-${hub.key}`}>
      <span className="hub-name"><hub.icon size={13} strokeWidth={2} />{hub.label}</span>
      <nav className="hub-tabs" aria-label={`${hub.label} sections`}>
        {hub.children.map((c) => { const on = active?.key === c.key; return (
          <span key={c.key} className={`hub-tab-wrap ${on ? "hub-tab-wrap-active" : ""}`}>
            <Link to={c.to} className={`hub-tab ${on ? "hub-tab-active" : ""}`} aria-current={on ? "page" : undefined} data-testid={`hub-tab-${hub.key}-${c.key}`}>{c.label}</Link>
            <CountBadge n={countFor(counts, hub.key, c)} tone={c.tone} to={drillFor(hub.key, c)} hint={c.hint} testid={`hub-count-${hub.key}-${c.key}`} />
          </span>
        ); })}
      </nav>
    </div>
  );
}
